<template>
  <div id="game_rank_list_outer" v-if="currentPersonList != null">
    <div v-if="currentPersonList.length > 0">
      <div class="left" >
          <a v-for="(item, index) in leftMenuList"
             href="javascript:void(null);"
             @click="leftMenuClicked(index)"
             :class="leftIndex == index ? 'active' : ''"
             :key="'left_menu_item_' + index">{{item}}</a>
      </div>
      <div class="right" >
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{leftMenuList[leftIndex]}}榜</th>
              <th colspan=""></th>
              <th >场均</th>
              <th >总计</th>
            </tr>
          </thead>
          <tbody >
            <tr v-for="(item, index) in currentPersonList" :key="'player_rank_' + index" >
              <td>{{index + 1}}</td>
              <td v-if="false">
                <a :href="'/matches/games/player/' + item.id" target="_blank">
                  <img src="../../assets/shl_game_play_default.png" style="max-width: 60px;height: auto;">
                </a>
              </td>
              <td><a :href="'/matches/games/player/' + item.id" target="_blank">{{item.name}}</a></td>
              <td>{{perValue(item)}}</td>
              <td>{{totalValue(item)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else style="height: 200px;color: #333;display: flex;flex-direction: column;align-items: center;justify-content: center;background-color: white;">
      <span>暂无相关信息</span>
    </div>
  </div>
</template>

<script>
  import GameHttpManager from '../../js/outer-games-http-define';
export default {
  name: "GamesRankPage",
  data() {
    return {
      leftMenuList: [
        '得分',
        '两分',
        '三分',
        '篮板',
        '助攻',
      ],
      memberList: null,
      leftIndex: 0,
      matchList: null,
      personList: null,

      currentPersonList: null,
    }
  },

  computed: {

  },
  mounted() {
    this.loadMatchListData();
    this.loadPersonListData();
  },

  methods: {

    perValue(item) {
      let index = this.leftIndex;
      if (index == 0) {
        return item.scoreItem.per_field_score;
      } else if (index == 1) {
        return item.scoreItem.per_two_point_num;
      } else if (index == 2) {
        return item.scoreItem.per_three_point_num;
      } else if (index == 3) {
        return item.scoreItem.per_rebound_num;
      } else {
        return item.scoreItem.per_assist_num;
      }
    },
    totalValue(item) {
      let index = this.leftIndex;
      if (index == 0) {
        return item.scoreItem.field_score;
      } else if (index == 1) {
        return item.scoreItem.two_point_num;
      } else if (index == 2) {
        return item.scoreItem.three_point_num;
      } else if (index == 3) {
        return item.scoreItem.rebound_num;
      } else {
        return item.scoreItem.assist_num;
      }
    },

    loadPersonListData() {
      let _this = this;
      GameHttpManager.getPlayerListData(function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.personList = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
      });
    },

    loadMatchListData() {
      let _this = this;
      GameHttpManager.getPlayerGameListData(function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.matchList = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
      });
    },

    dealWithDataLoadSuccess() {
      let personList = this.personList;
      let matchList = this.matchList;
      if (personList == null || matchList == null) {
        return;
      }

      let tmpList = [];
      for (let i = 0; i < personList.length; i++) {
        let player = personList[i];

        let indexList = [];
        let playScoreList = [];

        for (let j = 0; j < matchList.length; j++) {
          let score = matchList[j];
          if (player.id == score.player_id) {
            playScoreList.push(score);
            indexList.push(j);
          }
        }

        for (let h = 0; h < indexList.length; h++) {
          matchList.splice(indexList[h], 1);
        }
        if (indexList.length > 0) {
          player.scoreList = playScoreList;
          tmpList.push(player);
        }
      }


      for (let i = 0; i < tmpList.length; i++) {
        let player = tmpList[i];
        let scoreList = player.scoreList;
        let matches = scoreList.length;

        let per_field_score = 0;
        let field_score = 0;

        let field_percentage = 0;
        let per_field_percentage = 0;

        let two_point_num = 0;
        let per_two_point_num = 0;

        let two_point_percentage = 0;
        let per_two_point_percentage = 0;

        let three_point_num = 0;
        let per_three_point_num = 0;
        let three_point_percentage = 0;
        let per_three_point_percentage = 0;

        let rebound_num = 0;
        let per_rebound_num = 0;

        let assist_num = 0;
        let per_assist_num = 0;


        for (let j = 0; j < scoreList.length; j++) {
          let item = scoreList[j];

          field_score += item.field_score;

          field_percentage += item.field_percentage;

          two_point_num += item.two_point_num;

          two_point_percentage += item.two_point_percentage;

          three_point_num += item.three_point_num;

          three_point_percentage += item.three_point_percentage;

          rebound_num += item.rebound_num;

          assist_num += item.assist_num;
        }

        per_assist_num =  assist_num/ matches;

        per_rebound_num = rebound_num / matches;

        per_field_percentage = field_percentage / matches;

        per_field_score = field_score / matches;

        per_two_point_num = two_point_num / matches;

        per_two_point_percentage = two_point_percentage / matches;

        per_three_point_num = three_point_num / matches;

        per_three_point_percentage = three_point_percentage / matches;

        per_field_score = new Number(per_field_score).toFixed(1);
        per_field_percentage = this.toPercent(per_field_percentage);

        per_two_point_num = new Number(per_two_point_num).toFixed(1);
        per_two_point_percentage = this.toPercent(per_two_point_percentage);

        per_three_point_num = new Number(per_three_point_num).toFixed(1);
        per_three_point_percentage = this.toPercent(per_three_point_percentage);

        per_rebound_num = new Number(per_rebound_num).toFixed(1);

        per_assist_num = new Number(per_assist_num).toFixed(1);


        let scoreItem = {
          matches,

          field_score,
          per_field_score,
          per_field_percentage,

          two_point_num,
          per_two_point_num,
          per_two_point_percentage,

          three_point_num,
          per_three_point_num,
          per_three_point_percentage,

          rebound_num,
          per_rebound_num,

          assist_num,
          per_assist_num,
        }

        player.scoreItem = scoreItem;
      }
      this.personList = tmpList;
      this.matchList = null;

      this.sortPersonList();
    },

    sortPersonList() {
      let index = this.leftIndex;

      let personList = [].concat(this.personList);

      if (personList == null) {
        return;
      }

      personList.sort(function (item1, item2) {
          if (index  == 0) {
            let num = item2.scoreItem.per_field_score - item1.scoreItem.per_field_score;
            if (num == 0) {
              num = item2.scoreItem.field_score - item1.scoreItem.field_score
            }
            return num;
          } else if (index == 1) {
            let num = item2.scoreItem.per_two_point_num - item1.scoreItem.per_two_point_num;
            if (num == 0) {
              num = item2.scoreItem.two_point_num - item1.scoreItem.two_point_num
            }
            return num;
          } else if (index == 2) {
            let num = item2.scoreItem.per_three_point_num - item1.scoreItem.per_three_point_num;
            if (num == 0) {
              num = item2.scoreItem.three_point_num - item1.scoreItem.three_point_num
            }
            return num;
          } else if (index == 3) {
            let num = item2.scoreItem.per_rebound_num - item1.scoreItem.per_rebound_num;
            if (num == 0) {
              num = item2.scoreItem.rebound_num - item1.scoreItem.rebound_num
            }
            return num;
          } else {
            let num = item2.scoreItem.per_assist_num - item1.scoreItem.per_assist_num;
            if (num == 0) {
              num = item2.scoreItem.assist_num - item1.scoreItem.assist_num
            }
            return num;
          }
      });

      let number = personList.length >= 10 ? 10 : personList.length;
      let tmp = personList.slice(0, number);
      this.currentPersonList = tmp;
    },

    leftMenuClicked(index) {
      this.leftIndex = index;
      this.sortPersonList();
    },
    itemClicked(item) {

    }
  }
}
</script>

<style scoped>

  #game_rank_list_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
  }



  #game_rank_list_outer > div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    background-color: #999;

  }

  #game_rank_list_outer > div .left {
    width: 20%;
    height: 100%;
    background-color: #999;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #game_rank_list_outer a {
    color: #333;
    text-decoration: none;
  }

  #game_rank_list_outer a:hover {
    color: #fc1a34;
  }

  #game_rank_list_outer > div .left a {
    font-weight: bold;
    font-size: 1.2rem;
    display: block;
    height: 81px;
    line-height: 81px;

  }

  #game_rank_list_outer > div .left a.active {
    color: #fc1a34;
    pointer-events: none;
  }

  #game_rank_list_outer > div .right {
    width: 80%;
    background-color: white;
  }
  #game_rank_list_outer > div .right {
  }


  #game_rank_list_outer > div .right table th, #game_rank_list_outer > div .right table td {
    height: 80px;
    line-height: 80px;
    padding: 0;
    text-align: center;
  }

  @media screen and (min-width: 768px) {
    #game_rank_list_outer {
      padding: 40px 30px;
    }

    #game_rank_list_outer > div .left {
      width: 15%;
    }

    #game_rank_list_outer > div .right {
      width: 85%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/GamesRankPage.vue